/* eslint-disable no-irregular-whitespace */
export const firstScreenLocales = {
  ru: {
    title: 'STONfi.pools',
    badge1: 'ИНТЕРАКТИВНЫЙ КУРС',
    badge2: 'КАК РАБОТАТЬ С ПУЛАМИ НА STON.fi',
    description: `Интересно, как работает DeFi? Потренируйтесь в обменах, предоставлении ликвидности, фарминге и стейкинге.\n\nНе нужно подключать кошелёк и использовать свои средства — всё происходит в симуляторе.`,
    start: 'НАЧАТЬ',
  },
  en: {
    title: 'STONfi.pools',
    badge1: 'INTERACTIVE COURSE',
    badge2: 'HOW TO WORK WITH POOLS ON STON.fi',
    description: `Curious about basic DeFi actions? Simulate swaps, liquidity provision, farming, and staking.\n\nNo need to connect your wallet or use your own funds — everything happens in a sandbox.`,
    start: 'START',
  },
};

export const secondScreenLocales = {
  ru: {
    title: 'Своп',
    description: `Давайте разберёмся, что такое своп, как правильно его совершать
и что происходит с токенами, когда вы их обмениваете.`,
    highlight: 'НАЖМИТЕ КНОПКУ СПРАВА,\nЧТОБЫ УГЛУБИТЬСЯ В ТЕОРИЮ!',
    theory: 'ТЕОРИЯ',
    practica: 'ПРАКТИКА',
    centerText: 'К ПОСТАВКЕ ЛИКВИДНОСТИ',
  },
  en: {
    title: 'Swap',
    description: `Let’s figure out what a swap is, how to do it correctly,
and what happens to your tokens when you perform this operation.`,
    highlight: 'CLICK THE RIGHT BUTTON\nTO LEARN THEORY!',
    theory: 'THEORY',
    practica: 'PRACTICE',
    centerText: 'TO LIQUIDITY PROVISION',
  },
};

export const secondTheoryLocales = {
  ru: {
    1: {
      title: 'Своп',
      theory: 'ТЕОРИЯ',
      question: 'Что такое своп?',
      description: `Своп — это обмен одного токена на другой. Да, вот так просто!

Допустим, у вас есть токен А, а вам нужен токен Б. 
В обычном мире вы ищете того, у кого есть этот токен, договариваетесь и надеетесь, что вас не обманут.
В DeFi это за вас делают смарт-контракты. Они хранятся на блокчейне и обеспечивают безопасность и прозрачность сделок.`,
      highlight:
        'ТАК ЧТО ЖЕ ПРОИСХОДИТ,\nС ВАШИМИ ТОКЕНАМИ, КОГДА\nВЫ СОЗДАЁТЕ ЗАПРОС НА СВОП?',
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    2: {
      title: 'Своп',
      theory: 'ТЕОРИЯ',
      question: 'Откуда берутся\nтокены для свопов?',
      description: `Погодите, а откуда тогда возьмутся токены, которые вы хотите получить?

Основа всех операций обмена токенов — пулы ликвидности, этакие «динамические хранилища» токенов. Работу пулов ликвидности обеспечивает смарт-контракт. Алгоритм пула блокирует определённое количество токенов А и токенов Б. Когда вы совершаете своп, смарт-контракт блокирует токены, которые вы отдаёте, в пуле ликвидности, и отдаёт вам нужные токены взамен.

Первую ликвидность в пул как правило кладёт проект, выпустивший токен — ведь если нет ликвидности, то обменивать нечего. Также пользователи могут пополнять пул ликвидности и получать доход — об этом мы расскажем в следующей главе.`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    3: {
      title: 'Своп',
      theory: 'ТЕОРИЯ',
      question: 'Как определяется \nстоимость токенов \nпри свопе?',
      description: `Пользователи постоянно совершают свопы. За один день соотношение токенов в одном пуле может значительно измениться: пользователи продают разные токены в разном объёме. Смарт-контракт, отталкиваясь от официальной стоимости токена на рынке, корректирует цену так, чтобы сбалансировать пул ликвидности. Если в нем осталось мало токена А, то покупка его будет дороже, а покупка токена Б — дешевле. Не переживайте: в популярных и крупных пулах цена от одной сделки изменяется незначительно — чаще всего менее чем на 0,01%.`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    4: {
      title: 'Своп',
      theory: 'ТЕОРИЯ',
      question: 'Параметры\nтранзакции',
      description: `Вы практически готовы к своим первым свопам на STON.fi! Но помните, что перед подтверждением транзакции всегда нужно проверить и перепроверить параметры операции. Вот какие параметры вы увидите перед свопом на STON.fi:`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
      modals: {
        route: {
          title: 'Route',
          text: 'Путь, который пройдут ваши средства, чтобы превратиться в нужный вам токен. Там будет указан пул ликвидности, с которым вы взаимодействуете при свопе выбранных токенов.',
        },
        blockchainFee: {
          title: 'Blockchain Fee',
          text: 'Комиссия блокчейна за проведение транзакции.',
        },
        minimumReceived: {
          title: 'Minimum Received',
          text: 'Случается, что цена токена сильно меняется прямо во время совершения транзакции. В таком случае пользователь, ожидающий получить определённую сумму, получает ощутимо меньше. STON.fi решает эту проблему: Minimum Received показывает, сколько токенов вы минимально получите. Если в момент, когда вы нажмёте Swap, цена токена значительно изменится и Minimum Received не сможет быть соблюден, операция будет автоматически отменена.',
        },
        exchangeRate: {
          title: 'Exchange Rate',
          text: 'Текущий курс получаемого токена к продаваемому.',
        },
        priceImpact: {
          title: 'Price Impact',
          text: 'Это влияние на цену, то есть изменение стоимости актива смарт-контрактом для балансировки пула ликвидности. В больших популярных пулах вы не заметите влияния на цену — но помните об этом показателе всегда. Мы считаем сделки с влиянием на цену выше 5% неоптимальными в подавляющем большинстве случаев и предупреждаем об этом в интерфейсе.',
        },
      },
    },
    5: {
      title: 'Поздравляем,\n вы готовы\n к практике!',
      practice: 'ПРАКТИКА',
      back: 'НАЗАД',
      highlight: 'КНОПКА СПРАВА - К ПРАКТИКЕ, КНОПКА СЛЕВА - ВЕРНУТЬСЯ НАЗАД',
    },
  },
  en: {
    1: {
      title: 'Swap',
      theory: 'THEORY',
      question: 'What is a swap?',
      description: `A swap is the exchange of one token for another. Yes, it’s that simple!

Let’s say you have token A, but you need token B.
In the traditional world, you\'d look for someone who has this token, negotiate with them, and hope you don’t get scammed.
In DeFi, smart contracts do this for you. They are stored on the blockchain and ensure the security and transparency of transactions.
`,
      highlight:
        'WHAT HAPPENS TO YOUR\n TOKENS WHEN YOU CREATE A SWAP REQUEST?',
      next: 'CONTINUE',
      back: 'BACK',
    },
    2: {
      title: 'Swap',
      theory: 'THEORY',
      question: 'Where do the tokens\nfor swaps come from?',
      description: `Wait, so where do the tokens you want to receive come from?

All swapping operations are based on liquidity pools, which are like “dynamic storages” of tokens. Liquidity pools are managed by smart contracts. The pool’s algorithm locks a certain amount of token A and token B. When you make a swap, the smart contract locks the tokens you give in the liquidity pool and gives you the needed tokens in return.

Initial liquidity is usually provided by the project that issued the token. Without liquidity, the token cannot be swapped. Users can also add liquidity and receive a share of the fees — we’ll talk about this in the next chapter.`,
      next: 'CONTINUE',
      back: 'BACK',
    },
    3: {
      title: 'Swap',
      theory: 'THEORY',
      question: 'How is the token price\ndetermined in a swap?',
      description: `Users constantly make swaps. In one day, the ratio of tokens in a pool can change significantly: users sell different tokens in different amounts. Depending on the pool, the smart contract automatically adjusts token prices to maintain balance within the pool. The price depends on the ratio of tokens in the pool. Don't worry: in popular and large pools, the price changes are minimal — usually <0,01%.`,
      next: 'CONTINUE',
      back: 'BACK',
    },
    4: {
      title: 'Swap',
      theory: 'THEORY',
      question: 'Transaction\nparameters',
      description: `You are almost ready for your first swaps on STON.fi! But remember: before confirming a transaction, always check and double-check the operation’s parameters. Here are the parameters you’ll see before swapping on STON.fi:`,
      next: 'CONTINUE',
      back: 'BACK',
      modals: {
        route: {
          title: 'Route',
          text: 'The path your funds will take to become the token you want. This will show the liquidity pool you interact with when swapping the selected tokens.',
        },
        blockchainFee: {
          title: 'Blockchain Fee',
          text: 'The blockchain fee for processing the transaction.',
        },
        minimumReceived: {
          title: 'Minimum Received',
          text: 'There have been cases where the token price changed significantly during a transaction: a user expecting a certain amount in exchange for tokens received much less. STON.fi solves this. Minimum Received shows the minimum amount of tokens you can expect to receive. If the token price changes drastically when you press Swap and the Minimum Received threshold can’t be met, the operation will be automatically canceled.',
        },
        exchangeRate: {
          title: 'Exchange Rate',
          text: 'The current rate of the received token to the sold token.',
        },
        priceImpact: {
          title: 'Price Impact',
          text: 'The change in asset price by the smart contract to balance the liquidity pool. In large popular pools, you won’t notice price impact — but always pay attention to this indicator. We consider swaps with price impact above 5% to be unprofitable in most cases and warn about this in the interface.',
        },
      },
    },
    5: {
      title: 'Congratulations,\n you are ready\n for practice!',
      practice: 'PRACTICE',
      back: 'BACK',
      highlight:
        'CLICK THE RIGHT BUTTON\nTO GO TO PRACTICE\n AND LEFT TO GO BACK!',
    },
  },
};

export const secondPracticaLocales = {
  ru: {
    title: 'Практика',
    question: 'Попробуйте совершить своп!',
    description: `Выберите токены для обмена, введите сумму и нажмите "Своп". Действия здесь симулируются — настоящие средства не используются.`,
    swapButton: 'Своп',
    selectToken: 'Выберите токен',
    amountPlaceholder: 'Введите сумму',
    successModal: {
      title: 'Своп выполнен!',
      text: 'Поздравляем! Вы успешно совершили своп в демо-режиме.',
      next: 'ДАЛЕЕ',
    },
    errorModal: {
      title: 'Упс!',
      text: 'Этого воображаемого токена нет на вашем воображаемом кошельке. Попробуйте обменять другой токен.',
      close: 'ПОПРОБОВАТЬ ЕЩЁ',
    },
    infoModal: {
      title: 'Как работает своп?',
      text: 'Своп — это обмен одного токена на другой по текущему курсу через пул ликвидности. В этом демо ваши средства не используются.',
      close: 'ПОНЯТНО',
    },
    from: 'Из',
    to: 'В',
    highlight:
      'ПОМНИТЕ, ЧТО ЗДЕСЬ ОПЕРАЦИИ СИМУЛИРУЮТСЯ, МОЖНО ЭКСПЕРИМЕНТИРОВАТЬ СКОЛЬКО УГОДНО!',
    duplicateError:
      'Нельзя обменять токен на такой же токен. Выберите другой токен для обмена.',
    insufficientBalanceError:
      'Количество токенов для обмена не может быть больше, чем количество токенов на счете.',
    zeroAmountError:
      'Нельзя совершить своп с нулевым количеством токенов. Введите количество больше нуля.',
    back: 'НАЗАД',
  },
  en: {
    title: 'Practice',
    question: 'Try to make a swap!',
    description: `Select tokens to swap, enter the amount, and press "Swap". All actions here are simulated — your real funds are not used.`,
    swapButton: 'Swap',
    selectToken: 'Select token',
    amountPlaceholder: 'Enter amount',
    successModal: {
      title: 'Swap completed!',
      text: 'Congratulations! You have successfully made a swap in demo mode.',
      next: 'CONTINUE',
    },
    errorModal: {
      title: 'Error',
      text: 'Please select tokens and enter an amount to swap.',
      close: 'CLOSE',
    },
    infoModal: {
      title: 'How does swap work?',
      text: 'A swap is an exchange of one token for another at the current rate via a liquidity pool. In this demo, your funds are not used.',
      close: 'GOT IT',
    },
    from: 'From',
    to: 'To',
    highlight:
      'REMEMBER: ALL OPERATIONS \n HERE ARE SIMULATED,\n FEEL FREE TO\n EXPERIMENT!',
    duplicateError:
      'You cannot swap a token for itself. Please select another token.',
    insufficientBalanceError:
      'The entered amount cannot be greater than the number of tokens in the account.',
    zeroAmountError:
      'Cannot swap with zero tokens. Please enter an amount greater than zero.',
    back: 'BACK',
  },
};

export const threeScreenLocales = {
  ru: {
    title: 'Поставка ликвидности',
    description: `Давайте разберемся, как работает пул ликвидности, зачем пользователи поставляют ликвидность и как сделать это самостоятельно.`,
    highlight: 'НАЖМИТЕ ПРАВУЮ КНОПКУ,\nЧТОБЫ УГЛУБИТЬСЯ В ТЕОРИЮ!',
    theory: 'ТЕОРИЯ',
    practica: 'ПРАКТИКА',
    centerText: 'К ФАРМИНГУ',
  },
  en: {
    title: 'Liquidity Provision',
    description: `Let’s figure out how a liquidity pool works, why users provide liquidity, and how to do it yourself.`,
    highlight: 'CLICK THE RIGHT BUTTON\nTO LEARN THEORY!',
    theory: 'THEORY',
    practica: 'PRACTICE',
    centerText: 'TO FARMING',
  },
};

export const threeTheoryLocales = {
  ru: {
    1: {
      title: 'Пул ликвидности',
      theory: 'ТЕОРИЯ',
      question: 'Что такое пул\n ликвидности?',
      description: `Представьте себе две чаши весов, на каждой из которых находятся токены. Когда \nкто‑то совершает обмен токена А на токен Б, \nс одной чаши весов снимается нужный \nпользователю токен, а продаваемый — кладётся на другую. Это и есть пул ликвидности — своеобразное динамическое «хранилище» токенов.`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    2: {
      title: 'Пул ликвидности',
      theory: 'ТЕОРИЯ',
      question: 'Откуда берется\n ликвидность?',
      description: `Обычно ликвидность обеспечивает сам проект, чей токен доступен для обмена. Ведь без начального запаса обменивать токены в пуле будет невозможно.\nТакже ликвидность поставляют пользователи. Эта операция доступна каждому — в этой интерактивной энциклопедии мы научим вас поставлять ликвидность.`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    3: {
      title: 'Пул ликвидности',
      theory: 'ТЕОРИЯ',
      question: 'Зачем поставлять\n ликвидность?',
      description: `Поставщики ликвидности получают вознаграждение: часть комиссий за совершение свопов.

Чем больше объем обменов в пуле, тем больше комиссий получают поставщики ликвидности. А объем обменов растет, когда в пуле много ликвидности — ведь это означает меньшее влияние каждой сделки на цену токена при обмене.`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    4: {
      title: 'Пул ликвидности',
      theory: 'ТЕОРИЯ',
      question: 'Как выбрать пул\n ликвидности?',
      description: `Обратите внимание на три главных показателя:`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
      buttons: {
        apr: 'APR, ANNUAL PERCENTAGE RATE',
        tvl: 'TVL, TOTAL VALUE LOCKED',
        volume: 'VOLUME, 24H',
      },
      modals: {
        apr: {
          title: 'APR, Annual \n Percentage Rate',
          text: 'Годовой процент вознаграждений. Вычисляется на основе \n данных за последние 24 часа. Этот показатель \n постоянно меняется.',
        },
        tvl: {
          title: 'TVL, Total Value\n Locked',
          text: 'Общая стоимость токенов, находящихся в пуле ликвидности, выраженная в долларах. Чем выше TVL, тем более крупные сделки доступны в пуле. Пулы с крайне низким TVL могут сделать транзакции убыточными.',
        },
        volume: {
          title: 'Volume, 24h',
          text: 'Объём обменов в этой паре за последние сутки. Чем выше, тем популярнее пара, а следовательно, выше и вознаграждения для поставщиков ликвидности.',
        },
      },
    },
    5: {
      title: 'Поздравляем,\n вы готовы\n к практике!',
      theory: 'ТЕОРИЯ',
      back: 'НАЗАД',
      highlight: 'КНОПКА СПРАВА - К ПРАКТИКЕ, КНОПКА СЛЕВА - ВЕРНУТЬСЯ НАЗАД',
      practica: 'ПРАКТИКА',
    },
  },
  en: {
    1: {
      title: 'Liquidity Pool',
      theory: 'THEORY',
      question: 'What is a liquidity\n pool?',
      description: `Imagine a set of scales holding two tokens. The balance between them depends on the rules of the specific pool — it doesn’t always mean equal value on both sides. When someone swaps token A for token B, token A is added to one side while token B is taken from the other. This shifting balance changes the price of each token dynamically — that’s the essence of a liquidity pool.`,
      next: 'CONTINUE',
      back: 'BACK',
    },
    2: {
      title: 'Liquidity Pool',
      theory: 'THEORY',
      question: 'Where does liquidity\n come from?',
      description: `Usually, liquidity is provided by the project whose token is available for swapping on a platfrom. Without an initial supply, swapping in the pool is impossible.\nLiquidity is also provided by users. This operation is available to everyone — in this interactive encyclopedia, we’ll teach you how to provide liquidity.`,
      next: 'CONTINUE',
      back: 'BACK',
    },
    3: {
      title: 'Liquidity Pool',
      theory: 'THEORY',
      question: 'Why provide\n liquidity?',
      description: `Liquidity providers get rewards for adding their tokens to the pool — they receive part of the fees whenever swaps happen.

The higher the swap volume in the pool, the more fees liquidity providers receive. Swapping volume grows when there’s a lot of liquidity in the pool — this means lower price impact during swaps.`,
      next: 'CONTINUE',
      back: 'BACK',
    },
    4: {
      title: 'Liquidity Pool',
      theory: 'THEORY',
      question: 'How to choose a\n liquidity pool?',
      description: `Pay attention to 3 main indicators:`,
      next: 'CONTINUE',
      back: 'BACK',
      buttons: {
        apr: 'APR, ANNUAL PERCENTAGE RATE',
        tvl: 'TVL, TOTAL VALUE LOCKED',
        volume: 'VOLUME, 24H',
      },
      modals: {
        apr: {
          title: 'APR, Annual \n Percentage Rate',
          text: 'Shows the projected annual rate of return for participants providing liquidity to a specific pool. It’s expressed as a percentage and usually calculated using data from the last 24 hours. A higher APR indicates that liquidity providers receive a larger share of pool rewards. This value is dynamic and may change over time depending on market activity and pool performance.',
        },
        tvl: {
          title: 'TVL, Total Value\n Locked',
          text: 'The total dollar value of tokens currently held in a liquidity pool. A higher TVL indicates deeper liquidity, allowing users to exchange larger amounts with lower price impact. Pools with very low TVL often have limited liquidity, which can make swaps less efficient or more volatile.',
        },
        volume: {
          title: 'Volume, 24h',
          text: 'The total amount of tokens exchanged in a specific pair over the past 24 hours. A higher volume indicates stronger activity and demand for that pair, as well as a more active flow of swaps within the pool.',
        },
      },
    },
    5: {
      title: 'Congratulations,\n you are ready\n for practice!',
      theory: 'THEORY',
      back: 'BACK',
      highlight:
        'CLICK THE RIGHT BUTTON\nTO GO TO PRACTICE\n AND LEFT TO GO BACK!',
      practica: 'PRACTICE',
    },
  },
};

export const threePracticaLocales = {
  ru: {
    1: {
      title: 'Пул ликвидности',
      practica: 'ПРАКТИКА',
      question: 'Куда поставить\nликвидность?',
      description: 'Выберите пул, в который вы бы поставили ликвидность.',
      table: {
        poolName: 'Название пула',
        apr: 'APR',
        tvl: 'TVL',
        volume: 'VOLUME, 24H',
      },
      pools: [
        { name: 'Token A / Token B', apr: '21%', tvl: '$196', volume: '$1' },
        {
          name: 'Token C / Token D',
          apr: '34%',
          tvl: '$3 056 869',
          volume: '$49 632',
        },
        { name: 'Token E / Token F', apr: '0,05%', tvl: '$65', volume: '$12' },
        { name: 'Token G / Token H', apr: '0%', tvl: '$199', volume: '$0' },
      ],
      modal: {
        selectPool: 'Выберите пул',
        actionCorrect: 'Перейти к поставке ликвидности',
        actionWrong: 'Как выбрать пул ликвидности?',
        feedback: {
          'Token A / Token B': {
            title: 'Упс!',
            description:
              'Кажется, вы выбрали не лучший пул ликвидности. Несмотря на многообещающий APR, здесь почти нет токенов, и в нем активности. Такой пул ликвидности лучше избегать.',
            isCorrect: false,
          },
          'Token C / Token D': {
            title: 'Отличный выбор!',
            description:
              'Теперь давайте симулируем поставку ликвидность в этот пул.',
            isCorrect: true,
          },
          'Token E / Token F': {
            title: 'Это далеко не лучший пул из предложенных',
            description:
              'Объем обменов за сутки здесь всего $12 — ваша доля с транзакций будет ничтожна.',
            isCorrect: false,
          },
          'Token G / Token H': {
            title: 'Упс!',
            description:
              'Кажется, вы выбрали не лучший пул ликвидности. Судя по APR и объёму обменов, этот пул вообще стоит без дела. Получить в нем токены невозможно.',
            isCorrect: false,
          },
        },
        showPools: 'Показать пулы',
      },
      back: 'НАЗАД',
    },
    2: {
      title: 'Пул ликвидности',
      practica: 'ПРАКТИКА',
      question: 'Поставка\nликвидности',
      description: `Для поставки ликвидности вам нужно положить токены на обе чаши весов. \nВведите количество одного из токенов, а алгоритм посчитает количество второго. \nЗатем нажмите Provide Liquidity.`,
      inputPlaceholder: '0.00',
      provideButton: 'ПОСТАВИТЬ ЛИКВИДНОСТЬ',
      inputEmpty: 'ВВЕДИТЕ КОЛИЧЕСТВО',
      errorTitle: 'Упс!',
      errorText:
        'В рамках обучения максимальная сумма ограничена 1000 TON для обоих токенов. На реальной бирже STON.fi вы сможете вносить любую сумму, которая у вас есть.',
      errorButton: 'ПОНЯТНО',
      successModal: {
        title: 'Отлично!',
        text: 'Вы успешно поставили ликвидность в пул. Теперь давайте посмотрим, что происходит дальше.',
        continue: 'ПРОДОЛЖИТЬ',
      },
      tokenA: 'TOKEN A',
      tokenB: 'TOKEN B',
      balanceA: '1000',
      balanceB: '75357.65',
      token1Label: 'Token 1',
      token2Label: 'Token 2',
      back: 'НАЗАД',
    },
    3: {
      title: 'Пул ликвидности',
      practica: 'ПРАКТИКА',
      question: 'Что происходит\nдальше?',
      description: `Токены в указанном объёме снимаются с вашего кошелька и отправляются в пул ликвидности! Не забывайте, что поставка ликвидности является транзакцией, а следовательно, вы оплачиваете комиссию в TON.`,
      continue: 'ПРОДОЛЖИТЬ',
      back: 'НАЗАД',
    },
    4: {
      title: 'Пул ликвидности',
      practica: 'ПРАКТИКА',
      question: 'Что происходит\nдальше?',
      description: `0,2-1% от каждой транзакции распределяется между всеми поставщиками ликвидности — и теперь вы в их числе! Размер награды зависит от вашей доли в пуле ликвидности.`,
      highlight: `Теперь вы мастер поставки ликвидности.  Нажмите правую кнопку, чтобы перейти к новой теме!`,
      realButton: 'А ТЕПЕРЬ — ПО-НАСТОЯЩЕМУ!',
      next: 'К ФАРМИНГУ',
      back: 'НАЗАД',
    },
  },
  en: {
    1: {
      title: 'Liquidity Pool',
      practica: 'PRACTICE',
      question: 'Where to provide\nliquidity?',
      description: 'Choose a pool where you would provide liquidity.',
      table: {
        poolName: 'Pool name',
        apr: 'APR',
        tvl: 'TVL',
        volume: 'VOLUME, 24H',
      },
      pools: [
        { name: 'Token A / Token B', apr: '21%', tvl: '$196', volume: '$1' },
        {
          name: 'Token C / Token D',
          apr: '34%',
          tvl: '$3 056 869',
          volume: '$49 632',
        },
        { name: 'Token E / Token F', apr: '0.05%', tvl: '$65', volume: '$12' },
        { name: 'Token G / Token H', apr: '0%', tvl: '$199', volume: '$0' },
      ],
      modal: {
        selectPool: 'Select a pool',
        actionCorrect: 'Continue',
        actionWrong: 'How to choose a liquidity pool?',
        feedback: {
          'Token A / Token B': {
            title: 'Oops!',
            description:
              'It seems you chose not the best liquidity pool. Despite the promising APR, there are almost no tokens here and no one is swapping. Better avoid such a pool.',
            isCorrect: false,
          },
          'Token C / Token D': {
            title: 'Great choice!',
            description:
              'Next up: providing liquidity to this pool. No tokens required.',
            isCorrect: true,
          },
          'Token E / Token F': {
            title: 'Not the best pool among the options',
            description:
              'The swap volume for the day is only $12 — your share of the fees will be negligible.',
            isCorrect: false,
          },
          'Token G / Token H': {
            title: 'Oops!',
            description:
              'It seems you chose not the best liquidity pool. Judging by the APR and swap volume, this pool is idle. It’s impossible to get tokens here.',
            isCorrect: false,
          },
        },
        showPools: 'Show pools',
      },
      back: 'BACK',
    },
    2: {
      title: 'Liquidity Pool',
      practica: 'PRACTICE',
      question: 'Providing\nliquidity',
      description: `To provide liquidity, you need to put an equivalent amount of both tokens on each side of the scale. \nEnter the amount of one token, and the algorithm will calculate the amount of the other. \nThen press Provide Liquidity.`,
      inputPlaceholder: '0.00',
      provideButton: 'PROVIDE LIQUIDITY',
      inputEmpty: 'ENTER AMOUNT',
      errorTitle: 'Oops!',
      errorText:
        'For training, the maximum amount is limited to 1000 TON for both tokens. On the real STON.fi exchange, you can deposit any amount you have.',
      errorButton: 'GOT IT',
      successModal: {
        title: 'Great!',
        text: "You have successfully provided liquidity to the pool. Now let's see what happens next.",
        continue: 'CONTINUE',
      },
      tokenA: 'TOKEN A',
      tokenB: 'TOKEN B',
      balanceA: '1000',
      balanceB: '75357.65',
      token1Label: 'Token 1',
      token2Label: 'Token 2',
      back: 'BACK',
    },
    3: {
      title: 'Liquidity Pool',
      practica: 'PRACTICE',
      question: 'What happens\nnext?',
      description: `The specified amount of tokens is withdrawn from your wallet and sent to the liquidity pool! Don’t forget that providing liquidity is a transaction, so you pay a TON fee.`,
      continue: 'CONTINUE',
      back: 'BACK',
    },
    4: {
      title: 'Liquidity Pool',
      practica: 'PRACTICE',
      question: 'What happens\nnext?',
      description: `0.2-1% of each transaction is distributed among all liquidity providers — and now you are one of them! The reward depends on your share in the pool.`,
      highlight: `NOW YOU ARE A LIQUIDITY\n PROVIDER MASTER. CLICK THE RIGHT BUTTON TO GO TO FARMING!`,
      realButton: 'NOW — FOR REAL!',
      next: 'TO FARMING',
      back: 'BACK',
    },
  },
};

export const fourScreenLocales = {
  ru: {
    title: 'Фарминг',
    description: `Давайте разберёмся, что такое фарминг токенов, чем он отличается
от поставки ликвидности и как фармить самостоятельно.`,
    highlight: 'НАЖМИТЕ ПРАВУЮ КНОПКУ,\nЧТОБЫ УГЛУБИТЬСЯ В ТЕОРИЮ!',
    theory: 'ТЕОРИЯ',
    practica: 'ПРАКТИКА',
    centerText: 'К СТЕЙКИНГУ',
  },
  en: {
    title: 'Farming',
    description: `Let’s figure out what token farming is, how it differs from liquidity provision, and how to farm yourself.`,
    highlight: 'CLICK THE RIGHT BUTTON\nTO LEARN THEORY!',
    theory: 'THEORY',
    practica: 'PRACTICE',
    centerText: 'TO STAKING',
  },
};

export const fourTheoryLocales = {
  ru: {
    1: {
      title: 'Фарминг',
      theory: 'ТЕОРИЯ',
      question: 'Что такое\n фарминг?',
      description: `Поставка ликвидности — не единственный способ помочь вашим токенам работать на вас. На STON.fi в любой момент времени доступно множество пулов ликвидности с функцией фарминга — обычно их называют фермами. \n 
Фарминг — это временная возможность получать дополнительные награды за поставку ликвидности в определённый пул. Награды обеспечивает проект, который выпустил токен. Сначала вы поставляете ликвидность в пул, затем начинаете фармить, и сразу начинаете получать дополнительные награды.`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    2: {
      title: 'Фарминг',
      theory: 'ТЕОРИЯ',
      question: 'Откуда берутся\nнаграды в ферме?',
      description: `Проекты, чьи токены доступны для обмена, заинтересованы в том, чтобы в их пулах ликвидности было больше средств — так пользователи смогут обеспечить большие объёмы обменов. Для этого проект спонсирует фарминг на STON.fi, а выделенные наградные токены распределяются между всеми участниками фарминга пропорционально объёму поставленной ими ликвидности.\n
Фарминг можно считать дополнительным поощрением от проекта, в чей пул вы поставляете ликвидность.`,
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    3: {
      title: 'Фарминг',
      theory: 'ТЕОРИЯ',
      question: 'Фарминг vs\nпоставка ликвидности',
      description: [
        'Сначала нужно поставить ликвидность, получить LP-токены, заблокировать в смарт-контракте LP-токены, и только затем начать «фармить». Не наоборот.',
        'При поставке ликвидности вы получаете долю комиссий с транзакций. При фарминге в дополнение к этой доле вы получаете награды непосредственно от проекта, ликвидность чьего токена вы поставляете.',
        'Фарминг запускается временно. Поставлять ликвидность можно в любой существующий пул без ограничений.',
        'Фарминг требует блокировки LP-токенов. О них сейчас и расскажем.',
      ],
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    4: {
      title: 'Фарминг',
      theory: 'ТЕОРИЯ',
      question: 'Как начать\nфармить?',
      steps: [
        {
          number: 1,
          text: `Выберите интересующий вас пул и поставьте в него ликвидность. Обратите внимание, что все доступные для фарминга пулы отмечены плашкой “Farm”.`,
        },
        {
          number: 2,
          text: `После поставки ликвидности вы получите LP-токены — специальный «билет», который подтверждает ваш статус поставщика ликвидности. Они моментально придут на ваш кошелёк в объёме, соответствующем объёму поставленной ликвидности — от вас не потребуется никаких дополнительных действий.`,
        },
        {
          number: 3,
          text: `Теперь в интерфейсе выбранного вами пула появится кнопка Fаrm. Нажмите её и подтвердите блокировку LP-токенов — вуаля, вы начали фармить и получать награды!`,
        },
      ],
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    5: {
      title: 'Фарминг',
      theory: 'ТЕОРИЯ',
      back: 'ВЕРНУТЬСЯ',
      highlight: 'КНОПКА СПРАВА - К ПРАКТИКЕ, КНОПКА СЛЕВА - ВЕРНУТЬСЯ НАЗАД',
      subscribe: 'Подписаться',
      mainConcepts:
        'Чтобы выбрать ферму на STON.fi, откройте список пулов ликвидности. Пулы, в которых доступен фарминг, отмечены специальным значком Farming. Просто выберите пул, добавьте ликвидность и начните фармить дополнительные токены.',
      rewards: 'Награды',
      rewardsTitle: 'Награды',
      rewardsText:
        'Объем выделенных проектом наград для участников фарминга. Чем больше наград, тем лучше!',
      farmingPeriod: 'Срок фарминга',
      farmingPeriodTitle: 'Срок фарминга',
      farmingPeriodText:
        'Каждая ферма имеет определённую дату завершения — впрочем, нередко фермы продлевают с новыми наградами. Не забудьте разблокировать LP-токены по завершении фермы.',
      lpTokensLock: 'Блокировка LP-токенов в смарт-контракте',
      lpTokensLockTitle: 'Блокировка LP-токенов в смарт-контракте',
      lpTokensLockText:
        'Некоторые фермы имеют специальное условие — минимальный срок фарминга. На это время ваши LP-токены будут заблокированы, и вы сможете выйти из фарминга только по окончании указанного срока. Если срок блокировки не указан, фарминг можно завершить в любой момент.',
      farmApr: 'Farm APR',
      farmAprTitle: 'Farm APR',
      farmAprText:
        'Годовой процент вознаграждений с фермы. Вычисляется на основе следующих данных:\n\n(1) размер пула;\n(2) объём заблокированных LP-токенов;\n(3) общий объём наград в ферме.\n\nЧем выше Farm APR, тем больше токенов получают участники фарминга. Этот показатель постоянно меняется.',
      question: 'Как выбрать\nферму?',
      description:
        'В нашем Telegram-канале мы каждую неделю рассказываем о фермах на STON.fi и доступных наградах. Подпишитесь на нас прямо сейчас, чтобы держать руку на пульсе.',
      next: 'ПРОДОЛЖИТЬ',
    },
    6: {
      title: 'Поздравляем,\n вы готовы\n к практике!',
      theory: 'ТЕОРИЯ',
      back: 'ВЕРНУТЬСЯ',
      highlight: 'КНОПКА СПРАВА - К ПРАКТИКЕ, КНОПКА СЛЕВА - ВЕРНУТЬСЯ НАЗАД',
      practica: 'ПРАКТИКА',
    },
  },
  en: {
    1: {
      title: 'Farming',
      theory: 'THEORY',
      question: 'What is\nfarming?',
      description: `Liquidity provision is not the only way to make your tokens work for you. On STON.fi, there are always many liquidity pools with farming enabled — usually called farms.\n
Farming is a temporary opportunity to earn extra rewards for providing liquidity. The rewards are provided by the project that issued the token. You first provide liquidity to the pool, then start farming, and immediately start receiving extra rewards.`,
      next: 'CONTINUE',
      back: 'BACK',
    },
    2: {
      title: 'Farming',
      theory: 'THEORY',
      question: 'Where do farm\nrewards come from?',
      description: `Projects whose tokens are available for swapping aim to keep their liquidity pools well-funded — this helps users swap tokens in larger amounts. To support this, some projects launch farming programs on STON.fi. The project allocates reward tokens, which are then distributed among all participants based on the amount of liquidity they’ve added. In simple terms, farming acts as an extra incentive from the project behind the pool.`,
      next: 'CONTINUE',
      back: 'BACK',
    },
    3: {
      title: 'Farming',
      theory: 'THEORY',
      question: 'Farming vs\nliquidity provision',
      description: [
        'First, you need to provide liquidity, get LP tokens, lock them in the smart contract, and only then start farming. Not the other way around.',
        'When providing liquidity, you get a share of transaction fees. When farming, you get rewards directly from the project whose token liquidity you provide — and also a share of transaction fees as a liquidity provider!',
        'Farming is launched temporarily. You can provide liquidity to any existing pool without restrictions.',
        'Farming requires locking LP tokens. We’ll tell you about them now.',
      ],
      next: 'CONTINUE',
      back: 'BACK',
    },
    4: {
      title: 'Farming',
      theory: 'THEORY',
      question: 'How to start\nfarming?',
      steps: [
        {
          number: 1,
          text: `Choose a pool you are interested in and provide liquidity to it. Note that all pools available for farming are marked with a \'Farm\' badge.`,
        },
        {
          number: 2,
          text: `After providing liquidity, you will receive LP tokens — a special "ticket" confirming your status as a liquidity provider. They will instantly arrive in your wallet in an amount corresponding to the liquidity you provided — you don’t need to do anything extra.`,
        },
        {
          number: 3,
          text: `Now, in the interface of your chosen pool, a \'Farm\' button will appear. Click it and confirm the locking of LP tokens — voila, you have started farming and receiving rewards!`,
        },
      ],
      next: 'CONTINUE',
      back: 'BACK',
    },
    5: {
      title: 'Farming',
      theory: 'THEORY',
      back: 'MAIN',
      highlight:
        'CLICK THE RIGHT BUTTON\nTO GO TO PRACTICE\nAND LEFT TO GO BACK!',
      subscribe: 'Subscribe to STON.fi channel',
      mainConcepts:
        'To choose a farm on STON.fi, go to the list of liquidity pools. Pools with active farming opportunities are marked with a special Farm badge. Select such a pool, provide liquidity, and start farming extra tokens.',
      rewards: 'Farming rewards',
      rewardsTitle: 'Farming rewards',
      rewardsText:
        'You receive extra tokens for participating in farming. These rewards are provided by the project interested in increasing the liquidity of its token.',
      farmingPeriod: 'Farming period',
      farmingPeriodTitle: 'Farming period',
      farmingPeriodText:
        'Farming is available only for a certain period. After the period ends, new rewards will not be accrued.',
      lpTokensLock: 'LP tokens lock',
      lpTokensLockTitle: 'LP tokens lock',
      lpTokensLockText:
        'To participate in farming, your LP tokens are locked in the smart contract for the farming period. After it ends, you can unlock them.',
      farmApr: 'Annual Percentage Rate (APR)',
      farmAprTitle: 'Annual Percentage Rate (APR)',
      farmAprText:
        'Shows the projected annual rate of return for farming in a specific pool. This value may change depending on the liquidity volume and number of participants.',
      question: "What's next?",
      description:
        'Now you know the main farming concepts. Check out more info using the buttons below or proceed to practice!',
      next: 'CONTINUE',
    },
    6: {
      title: 'Congratulations,\n you are ready\n for practice!',
      theory: 'THEORY',
      back: 'BACK',
      highlight:
        'CLICK THE RIGHT BUTTON\nTO GO TO PRACTICE\n AND LEFT TO GO BACK!',
      practica: 'PRACTICE',
    },
  },
};

export const fourPracticaLocales = {
  ru: {
    1: {
      title: 'Фарминг',
      practica: 'ПРАКТИКА',
      question: 'Порядок действий',
      description:
        'Отметьте порядок действий для участия в фарминге. Будьте внимательны: в списке есть несколько лишних вариантов — их отмечать не нужно.',
      back: 'НАЗАД',
    },
    2: {
      title: 'Фарминг',
      practica: 'ПРАКТИКА',
      question: 'Что происходит\n с токенами\n при фарминге?',
      text: `Алгоритм фермера: \n\n1. Поставьте ликвидность.\n2. Получите LP-токены.\n3. Нажмите кнопку Farm. \n4. LP-токены заблокировались в смарт-контракте. \n5. Вам уже приходят дополнительные награды за фарминг!`,
      highlight: `ТЕПЕРЬ ВЫ МАСТЕР ФАРМИНГА! \nНАЖМИТЕ ПРАВУЮ КНОПКУ, ЧТОБЫ ПРОДОЛЖИТЬ`,
      realButton: 'А ТЕПЕРЬ — ПО-НАСТОЯЩЕМУ!',
      hint: 'Смахните вверх ещё раз, чтобы перейти к изучению фарминга',
      next: 'К СТЕЙКИНГУ',
      back: 'НАЗАД',
    },
  },
  en: {
    1: {
      title: 'Farming',
      practica: 'PRACTICE',
      question: 'Action order',
      description:
        'Mark the correct order of actions to participate in farming.',
      back: 'BACK',
    },
    2: {
      title: 'Farming',
      practica: 'PRACTICE',
      question: 'What happens\nto tokens\nin farming?',
      text: `Farmer’s Algorithm: \n\n1. Provide liquidity. \n2. Receive LP tokens. \n3. Click the Farm button. \n4. Your LP tokens are locked in the smart contract. \n5. You’re already earning extra farming rewards!
`,
      highlight: `NOW YOU ARE A FARMING MASTER!`,
      realButton: 'NOW — FOR REAL!',
      hint: 'Swipe up again to proceed to farming study',
      next: 'TO STAKING',
      back: 'BACK',
    },
  },
};

export const fiveScreenLocales = {
  ru: {
    title: 'Стейкинг',
    description:
      'Поздравляем всех, кто забрался так далеко! До настоящего мастерства вас отделяет понимание всего одной операции. Давайте разберёмся, что такое стейкинг, зачем им заниматься и как застейкать токены STON.',
    highlight: 'НАЖМИТЕ ПРАВУЮ КНОПКУ,\nЧТОБЫ УГЛУБИТЬСЯ В ТЕОРИЮ!',
    theory: 'ТЕОРИЯ',
    practica: 'ПРАКТИКА',
    centerText: 'НА ГЛАВНУЮ',
  },
  en: {
    title: 'Staking',
    description:
      'Congratulations to everyone who made it this far — you are one step away from true mastery on STON.fi. Let’s finally figure out what staking is, why do it, and how to stake STON tokens.',
    highlight: 'CLICK THE RIGHT BUTTON\nTO LEARN THEORY!',
    theory: 'THEORY',
    practica: 'PRACTICE',
    centerText: 'TO THE MAIN SCREEN',
  },
};

export const fiveTheoryLocales = {
  ru: {
    1: {
      title: 'Стейкинг',
      theory: 'ТЕОРИЯ',
      question: 'Что такое\n стейкинг?',
      description:
        'Стейкинг — это блокировка токенов в смарт-контракте за вознаграждение. STON.fi предлагает стейкинг STON на срок от 3 месяцев до 2 лет с наградами в виде пропуска в DAO и токенами GEMSTON.',
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    2: {
      title: 'Стейкинг',
      theory: 'ТЕОРИЯ',
      question: 'Что даёт стейкинг\nна STON.fi?',
      description: [
        'Мы реализовали действительно гибкую систему необычных наград. Вот что можно получить за стейкинг STON:\n',
        'Соулбаунд-NFT ARKENSTON. Это специальный NFT, который навсегда привязывается к вашему кошельку: продать или отправить другу его невозможно. ARKENSTON даёт вам право участвовать в STON.fi DAO — децентрализованном органе управления, состоящем из других пользователей, стейкеров и энтузиастов. Именно DAO принимает ответственные решения о будущем проекта. Входной билет туда получает каждый стейкер! Чем больше стейкаете, тем сильнее голос при принятии решений (voting power).',
        'Токен GEMSTON. Это токен STON.fi в дополнение к основному токену STON. GEMSTON можно обменивать на другие токены, а также использовать его в различных активностях, предлагаемых STON.fi (следите за обновлениями в нашем Telegram-канале!).',
      ],
      next: 'ПРОДОЛЖИТЬ',
      back: 'ВЕРНУТЬСЯ',
    },
    3: {
      title: 'Поздравляем,\n вы готовы\n к практике!',
      theory: 'ТЕОРИЯ',
      highlight: 'КНОПКА СПРАВА - К ПРАКТИКЕ, КНОПКА СЛЕВА - ВЕРНУТЬСЯ НАЗАД',
      practica: 'ПРАКТИКА',
      back: 'ВЕРНУТЬСЯ',
    },
  },
  en: {
    1: {
      title: 'Staking',
      theory: 'THEORY',
      question: 'What is\nstaking?',
      description:
        'Staking is locking tokens in a smart contract for a reward. STON.fi offers staking STON for a period from 3 months to 2 years with rewards in the form of DAO passes and GEMSTON tokens.',
      next: 'CONTINUE',
      back: 'BACK',
    },
    2: {
      title: 'Staking',
      theory: 'THEORY',
      question: 'What does staking\ngive on STON.fi?',
      description: [
        'We have implemented a truly flexible system of unique rewards. Here’s what you can get for staking STON:\n',
        'ARKENSTON soulbound NFT. This special NFT is forever tied to your wallet: you cannot sell or send it to a friend. ARKENSTON makes you a member of the STON.fi DAO — the real governing body, consisting of other users, stakers, and STON.fi enthusiasts. The DAO makes important decisions about the project’s future. Every staker gets a ticket! The more you stake, the stronger your voting power.',
        'GEMSTON token. This is an additional STON.fi token, alongside the main STON token. GEMSTON can be swapped for other tokens and used in various activities offered by STON.fi (follow updates in our Telegram channel!).',
      ],
      next: 'CONTINUE',
      back: 'BACK',
    },
    3: {
      title: 'Congratulations,\n you are ready\n for practice!',
      theory: 'THEORY',
      highlight:
        'CLICK THE RIGHT BUTTON\nTO GO TO PRACTICE\n AND LEFT TO GO BACK!',
      practica: 'PRACTICE',
      back: 'BACK',
    },
  },
};

export const fivePracticaLocales = {
  ru: {
    1: {
      title: 'Стейкинг',
      practica: 'ПРАКТИКА',
      description:
        'Застейкать STON проще простого! Укажите любое количество STON, установите слайдер на нужную длительность стейкинга и подтвердите операцию. Напоминаем, что в рамках этой энциклопедии действия симулируются – не бойтесь экспериментировать!',
      amountLabel: 'Количество',
      durationLabel: 'Длительность',
      months: 'месяцев(а)',
      mShort: 'м',
      stakeButton: 'Застейкать',
      modalTitle: 'Упс!',
      modalText:
        'В рамках обучения максимальная сумма ограничена 1000 STON. На STON.fi вы сможете застейкать любую сумму STON, которая у вас есть.',
      modalButton: 'ПОНЯТНО',
      back: 'НАЗАД',
    },
    2: {
      congratsTitle: 'Поздравляем!',
      congratsText:
        'Вы только что завершили вступительный курс и овладели базовыми навыками работы со STON.fi. Сохраните сертификат и поделитесь успехом в социальных сетях. Сертификат обязательно пригодится в будущем ;)',
      courseTitle: 'ИНТЕРАКТИВНЫЙ КУРС ПО DeFi',
      status: 'Мастер',
      realButton: 'А ТЕПЕРЬ — ПО-НАСТОЯЩЕМУ!',
      advicesTitle: 'ВОТ НЕСКОЛЬКО ПОЛЕЗНЫХ ССЫЛОК ОТ НАС:',
      telegramAdvice: 'ПОДПИШИТЕСЬ НА STON.fi \nВ TELEGRAM!',
      telegramAdviceTitle: 'Подпишитесь на STON.fi в Telegram!',
      telegramAdviceText:
        'Это наш официальный канал. Все новости, активности, эирдропы, обновления и изменения мы присылаем туда – держите руку на пульсе и следите за обновлениями!',
      subscribeButton: 'ПОДПИСАТЬСЯ',
      chatAdvice: 'ОБЩАЙТЕСЬ С ДРУГИМИ \nСТОНФАЕРАМИ!',
      chatAdviceTitle: 'Общайтесь с другими стонфаерами!',
      chatAdviceText:
        'Не стесняйтесь задавать вопросы — наши сотрудники всегда приходят на помощь!',
      chatButton: 'ЧАТ В TELEGRAM',
      discordButton: 'ПОРТАЛ В DISCORD',
      restartButton: 'НАЧАТЬ ЗАНОВО',
      back: 'НАЗАД',
      saveCertificate: 'СОХРАНИТЬ СЕРТИФИКАТ',
      certificateIsGenerating: 'Сертификат генерируется',
      goToCertificate: 'ПЕРЕЙТИ К СЕРТИФИКАТУ',
      viewCertificate: 'ПОДЕЛИТЬСЯ СЕРТИФИКАТОМ',
      shareButton: 'Поделиться',
      shareButtonLoading: 'Поделиться...',
      shareGeneratingLinks: 'Генерация ссылок для шеринга...',
      shareText: '🎓 Я завершил курс DeFi на STON.fi и получил сертификат!',
      shareTextTwitter:
        '🎓 Я завершил курс DeFi на @ston_fi и получил сертификат!',
      shareErrorText: 'Ошибка при попытке поделиться сертификатом',
      certificateAltText: 'Сертификат STONfi.pools',
    },
  },
  en: {
    1: {
      title: 'Staking',
      practica: 'PRACTICE',
      description:
        'Staking STON is super easy! Enter any amount of STON, set the slider to the desired staking duration, and confirm the operation. Remember, in this guide everything is a simulation – feel free to experiment!',
      amountLabel: 'Amount',
      durationLabel: 'Duration',
      months: 'months',
      mShort: 'm',
      stakeButton: 'Stake',
      modalTitle: 'Oops!',
      modalText:
        'For this training, the maximum amount is limited to 1000 STON. On STON.fi, you can stake any STON amount you have.',
      modalButton: 'GOT IT',
      back: 'BACK',
    },
    2: {
      congratsTitle: 'Congratulations!',
      congratsText:
        'You have just completed the STON.fi interactive course and mastered the basic skills of a true Stonfier. Save your certificate and share your success on social media. You’ll definitely need your certificate later ;)',
      courseTitle: 'DeFi INTERACTIVE COURSE',
      status: 'Master',
      realButton: 'NOW — FOR REAL!',
      advicesTitle: 'HERE ARE SOME USEFUL \nLINKS FROM US:',
      telegramAdvice: 'SUBSCRIBE TO STON.fi \nON TELEGRAM!',
      telegramAdviceTitle: 'Subscribe to STON.fi on Telegram!',
      telegramAdviceText:
        'This is our official channel. All news, activities, airdrops, updates, and changes are sent there – stay tuned and keep up to date!',
      subscribeButton: 'SUBSCRIBE',
      chatAdvice: 'CHAT WITH OTHER \nSTONFIERS!',
      chatAdviceTitle: 'Chat with other stonfiers!',
      chatAdviceText:
        'Don’t hesitate to ask questions — our team is always ready to help!',
      chatButton: 'TELEGRAM CHAT',
      discordButton: 'DISCORD PORTAL',
      restartButton: 'START OVER',
      back: 'BACK',
      saveCertificate: 'SAVE CERTIFICATE',
      certificateIsGenerating: 'Certificate is being generated',
      goToCertificate: 'GO TO CERTIFICATE',
      viewCertificate: 'SHARE CERTIFICATE',
      shareButton: 'Share',
      shareButtonLoading: 'Sharing...',
      shareGeneratingLinks: 'Generating sharing links...',
      shareText:
        '🎓 I completed the DeFi course on STON.fi and got my certificate!',
      shareTextTwitter:
        '🎓 I completed the DeFi course on @ston_fi and got my certificate!',
      shareErrorText: 'Error sharing certificate',
      certificateAltText: 'STONfi.pools Certificate',
    },
  },
};
